const audiences = [
  {
    icon: 'ri-user-star-line',
    title: 'Собственникам и руководителям',
    desc: 'Если необходимо понимать потенциал команды и принимать решения о развитии сотрудников.',
  },
  {
    icon: 'ri-team-line',
    title: 'HR и L&D',
    desc: 'Если необходимо систематизировать оценку и развитие сотрудников в компании.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Компаниям, которые формируют кадровый резерв',
    desc: 'Для подготовки будущих руководителей и ключевых специалистов.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Растущим компаниям',
    desc: 'Когда прежние подходы к оценке сотрудников перестают работать.',
  },
  {
    icon: 'ri-loop-left-line',
    title: 'Компаниям после изменений',
    desc: 'При изменении структуры, процессов, ролей или требований к сотрудникам.',
  },
];

export default function SuitableFor() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Для кого подходит
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Оценка сотрудников приносит пользу разным категориям компаний и ролей.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {audiences.map((a, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-100 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${a.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{a.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}